<template>
    <div class="faq--list">
        <div v-for="(item, index) in list" :class="{active: active === index}" class="faq-wrapper" v-bind:key="index">
            <div class="container-fluid">
                <div class="faq--item">
                    <div @click="active = index" class="faq--item--heading">
                        <div class="faq--item--count">
                            Q{{index+1}}
                        </div>
                        <div class="faq--item--title">
                            {{item.title}}
                        </div>
                        <div class="faq--item--dropdown">
                            <template v-if="active === index">
                            -
                            </template>
                            <template v-else>+</template>
                        </div>
                    </div>
                    <div v-show="active === index" class="faq--item-content">
                    {{item.content}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            list: Array,
        },
        data: () => ({
            active: -1,
        }),

        mounted() {
            // console.log('Component mounted.')
        }
    }
</script>